import Tooltip from '@mui/material/Tooltip';
import StyledWrapper from '../../../IndividualProgram/style';
import { formatTimestamp } from '../../../../utils/dateUtils';

const BasicCellText = ({
	cellValues,
	StartIcon,
	isLink,
	isDate,
	marginLeft,
	iconColor,
	isCurrentStage,
	className
}) => {
	const formattedText = isDate
		? formatTimestamp(cellValues?.formattedValue)
		: cellValues?.formattedValue;

	return (
		<StyledWrapper.CellContainer
			className={className}
			marginLeft={marginLeft}
			data-testid={`cellContainer-${cellValues?.field}-${cellValues?.id}`}
		>
			{cellValues?.formattedValue && StartIcon && (
				<StartIcon isCurrentStage={isCurrentStage} customColor={iconColor} isActive />
			)}
			<Tooltip arrow placement="top" title={cellValues?.formattedValue ? formattedText : 'n/a'}>
				{!isLink ? (
					<StyledWrapper.CardRowInfo
						width={'100%'}
						data-testid={`rowInfo-${cellValues?.field}-${cellValues?.id}`}
					>
						{cellValues?.formattedValue ? formattedText : 'n/a'}
					</StyledWrapper.CardRowInfo>
				) : (
					<StyledWrapper.CardRowInfoLink
						width={'100%'}
						data-testid={`rowLink-${cellValues?.field}-${cellValues?.id}`}
					>
						{cellValues?.formattedValue ? formattedText : 'n/a'}
					</StyledWrapper.CardRowInfoLink>
				)}
			</Tooltip>
		</StyledWrapper.CellContainer>
	);
};

export default BasicCellText;
